// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 684 ? "Admin" : chunkId) + "." + {"205":"0792310bcf5eba55bfd1","684":"7d30d414e779e82f0336"}[chunkId] + ".js";
};